import { render, staticRenderFns } from "./partenr-income-earnings.vue?vue&type=template&id=00a95ee2&scoped=true&"
import script from "./partenr-income-earnings.vue?vue&type=script&lang=js&"
export * from "./partenr-income-earnings.vue?vue&type=script&lang=js&"
import style0 from "./partenr-income-earnings.vue?vue&type=style&index=0&id=00a95ee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a95ee2",
  null
  
)

export default component.exports